t = require('views/internal/teacup-with-helpers')('plugin_chrome')

module.exports = t.renderable ({ fullscreen, resizable }) ->
  if resizable
    t.div '.js-plugin-chrome-content.plugin-chrome-wrapper.u-relative', ->
      t.div '.js-resize-board-bar.resize-handle-wrapper', ->
        t.div '.board-bar-resize-handle'
  else if fullscreen
    t.div '.js-plugin-chrome-content.plugin-chrome-wrapper.fullscreen'
  else
    t.div '.js-plugin-chrome-content.plugin-chrome-wrapper'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/plugin_chrome_wrapper.coffee